import { render, staticRenderFns } from "./multipleaddress.vue?vue&type=template&id=7cfbf8ca&scoped=true&"
import script from "./multipleaddress.vue?vue&type=script&lang=js&"
export * from "./multipleaddress.vue?vue&type=script&lang=js&"
import style0 from "./multipleaddress.vue?vue&type=style&index=0&id=7cfbf8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfbf8ca",
  null
  
)

export default component.exports